import React from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";
import {InfoIcon} from "../assets/icons/Icons";
import "../assets/scss/components/custom-tooltip.scss";
const CustomTooltip = ({ icon, message }) => {
    const tooltipId = `tooltip-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className="custom-tooltip">
            <div className="custom-tooltip__icon" data-tooltip-id={tooltipId}>
                {icon ? icon : <InfoIcon/>}
            </div>
            <ReactTooltip
                delayHide={100} // 1 second delay before hiding
                delayShow={200} // 0.5 seconds delay before showing
                className="custom-tooltip__message"
                id={tooltipId} place="top"
                effect="solid"
            >
                {message}
            </ReactTooltip>
        </div>

    );
};

export default CustomTooltip;
